import { PortaleId } from "@/api";
import logoGatti from "@/assets/logo_gatti.png";
import logoPortaleBackgroundColored from "@/assets/logo_gattifuture__background_blue.png";
import logoGattiFutureBackgroundTransparent from "@/assets/logo_gattifuture__background_transparent.png";
import logoGattiFutureChip from "@/assets/logo_gattifuture_chip.png";
import logoPraevidere from "@/assets/logo_praevidere.png";
import logoForesight2 from "@/assets/logo_foresight_2.png";
import logoPraevidereChip from "@/assets/logo_praevidere_chip.png";
import ondeGattiFutureBottomLeft from "@/assets/onde_gattifuture_bottom_left.png";
import ondeGattiFutureTopRight from "@/assets/onde_gattifuture_top_right.png";
import ondePraevidereBottomLeft from "@/assets/onde_praevidere_bottom_left.png";
import foresightDoublePlus from "@/assets/foresign_double_pluss.png";
import { ReactNode } from "react";
import { WelcomeToTheFuture } from "../elements/CoverLayout/WelcomeToTheFuture";
import { _portaleUtilsData } from "./portaleUtilsData";
import { Box, Typography } from "@mui/material";
import logo_sala_1 from "@/assets/logo_sala_1.webp";
import logo_sala_2 from "@/assets/logo_sala_2.webp";

export interface PortaleHelper {
  id: PortaleId;
  aziendaNome: string;
  aziendaLogo: string;

  primaryColor: string;
  secondaryColor: string;

  portaleNome: string;
  portaleLogoBackgroundColored: string;
  portaleLogoBackgroundTransparent: string;
  portaleChipIcon: string;
  portaleChipColor: string;

  coverTopRight: ReactNode;
  coverBottomLeft: ReactNode;
  toolbarTopRightImage: string | null;

  qrCodeHost: string;
}

const hostInfo = {
  // GattiFuture
  localhost: {
    portaleId: _portaleUtilsData.gattiFuture.id,
    qrCodeHostGattiFuture: "localhost",
    qrCodeHostPraevidere: "praevidere.local",
    qrCodeHostSala: "sala.local",
  },
  "stage.gattifiltrazionilubrificanti.starktech.online": {
    portaleId: _portaleUtilsData.gattiFuture.id,
    qrCodeHostGattiFuture:
      "stage.gattifiltrazionilubrificanti.starktech.online",
    qrCodeHostPraevidere: "stage.praevidere.starktech.online",
    qrCodeHostSala: "",
  },
  "gattifuture.it": {
    portaleId: _portaleUtilsData.gattiFuture.id,
    qrCodeHostGattiFuture: "gattifuture.it",
    qrCodeHostPraevidere: "foresight.praevidere.it",
    qrCodeHostSala: "",
  },
  "gattifuture.gattifiltrazionilubrificanti.it": {
    portaleId: _portaleUtilsData.gattiFuture.id,
    qrCodeHostGattiFuture: "gattifuture.it",
    qrCodeHostPraevidere: "foresight.praevidere.it",
    qrCodeHostSala: "",
  },

  // ForeSight
  "praevidere.local": {
    portaleId: _portaleUtilsData.praevidere.id,
    qrCodeHostGattiFuture: "localhost",
    qrCodeHostPraevidere: "praevidere.local",
    qrCodeHostSala: "sala.local",
  },
  "stage.praevidere.starktech.online": {
    portaleId: _portaleUtilsData.praevidere.id,
    qrCodeHostGattiFuture:
      "stage.gattifiltrazionilubrificanti.starktech.online",
    qrCodeHostPraevidere: "stage.praevidere.starktech.online",
    qrCodeHostSala: "",
  },
  "foresight.praevidere.it": {
    portaleId: _portaleUtilsData.praevidere.id,
    qrCodeHostGattiFuture: "gattifuture.it",
    qrCodeHostPraevidere: "foresight.praevidere.it",
    qrCodeHostSala: "",
  },

  // SALA
  "sala.local": {
    portaleId: _portaleUtilsData.sala.id,
    qrCodeHostGattiFuture: "localhost",
    qrCodeHostPraevidere: "praevidere.local",
    qrCodeHostSala: "sala.local",
  },
  "demo-sala.gattifiltrazionilubrificanti.starktech.online": {
    portaleId: _portaleUtilsData.sala.id,
    qrCodeHostGattiFuture: "demo.gattifiltrazionilubrificanti.starktech.online",
    qrCodeHostPraevidere: "",
    qrCodeHostSala: "",
  },
};

const hostWithoutPort = window.location.host.split(":")[0];

export function getPortaleInfo() {
  let info = hostInfo[hostWithoutPort as keyof typeof hostInfo];
  if (!info) {
    console.warn(`Host '${hostWithoutPort}' sconosciuto`);
    info = hostInfo["gattifuture.it"];
  }

  return info;
}

export function getPortaleId(): PortaleId {
  const info = getPortaleInfo();
  return info.portaleId;
}

const info = getPortaleInfo();

export const portaleHelpers: {
  [portaleId in PortaleId]: PortaleHelper;
} = {
  // GattiFuture
  1: {
    ..._portaleUtilsData.gattiFuture,

    aziendaLogo: logoGatti,

    portaleLogoBackgroundColored: logoPortaleBackgroundColored,
    portaleLogoBackgroundTransparent: logoGattiFutureBackgroundTransparent,
    portaleChipIcon: logoGattiFutureChip,
    portaleChipColor: "rgba(0, 0, 0, 0.08)",

    coverTopRight: WelcomeToTheFuture,

    toolbarTopRightImage: ondeGattiFutureTopRight,
    coverBottomLeft: (
      <img
        src={ondeGattiFutureBottomLeft}
        style={{
          position: "fixed",
          left: 0,
          bottom: 0,
          minWidth: 500,
          width: "50vw",
        }}
        alt="GattiFuture"
      />
    ),

    qrCodeHost: info.qrCodeHostGattiFuture,
  },

  // ForeSight
  2: {
    ..._portaleUtilsData.praevidere,

    aziendaLogo: logoPraevidere,

    portaleLogoBackgroundColored: logoForesight2,
    portaleLogoBackgroundTransparent: logoForesight2,
    portaleChipIcon: logoPraevidereChip,
    portaleChipColor: "#4AA0AF",

    coverTopRight: (
      <Box
        sx={{
          display: { xs: "none", md: "flex" },
          color: "#4AA0AF",
        }}
      >
        <Typography>
          Powered by Novus,
          <br /> our predictive Ai
        </Typography>
      </Box>
    ),
    toolbarTopRightImage: null,
    coverBottomLeft: (
      <Box
        sx={{
          position: "fixed",
          left: "5vmin",
          bottom: "5vmin",
          "@media (max-width:600px)": {
            display: "none",
          },
        }}
      >
        <img
          src={foresightDoublePlus}
          style={{
            minWidth: 100,
            width: 100,
          }}
          alt="ForeSight"
        />
      </Box>
    ),

    qrCodeHost: info.qrCodeHostPraevidere,
  },

  // SALA
  3: {
    ..._portaleUtilsData.sala,

    aziendaLogo: logo_sala_1,

    portaleLogoBackgroundColored: logo_sala_2,
    portaleLogoBackgroundTransparent: logo_sala_2,
    portaleChipIcon: logo_sala_2,
    portaleChipColor: "#D0D0D0",

    coverTopRight: (
      <Box
        sx={{
          display: { xs: "none", md: "flex" },
        }}
      >
        <Typography>
          powered by{" "}
          <a
            style={{ fontWeight: "bold", color: "#E5AD49" }}
            href="https://www.gattifiltrazionilubrificanti.it/"
          >
            Gatti Filtrazioni Lubrificanti Srl
          </a>
        </Typography>
      </Box>
    ),
    toolbarTopRightImage: null,
    coverBottomLeft: null,

    qrCodeHost: info.qrCodeHostSala,
  },
} as const;
